import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
import againRequest from './againRequest'
import { getToken, getFirstCommunityId, getCurrentOrganizationId } from '@/utils/auth'
import { noIntercept, needCommunityId, noNeedOrganizationId, noErrMsgPopup } from '@/utils/whiteList'

const service = axios.create({
  timeout: 10_000,
  retries: 3, // 重复请求次数
  retryDelay: 2000, // 重复请求间隔时间
  headers: { 'Content-Type': 'application/json', Terminal: 3, flowTerminal: 5 },
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.throttleUrl = config.url
    if (config.method === 'post') {
      config.data = config.data || {}
      config.data.token = getToken()

      if (!config.data.organizationId && !noNeedOrganizationId.includes(config.url))
        config.data.organizationId = getCurrentOrganizationId() || store.getters.organizationInfo.organizationId

      if (needCommunityId.includes(config.url) && !config.data.communityId && config.data.communityId !== undefined) {
        config.data.communityId = store.getters.firstCommunityId || getFirstCommunityId('firstCommunityId')
      }
    }
    return config
  },
  error => Promise.reject(error)
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data instanceof Blob) return response

    if (response.data && (response.data.errCode === 1030 || response.data.errCode === 1011 || response.data.errCode === 1001)) {
      store.dispatch('user/resetToken')
      router.push('/login')
      return Promise.reject('登录已失效，请重新登录')
    }
    if (response.data && (response.data.errCode === 502 || response.data.errCode === 503 || response.data.errCode === 500)) {
      store.dispatch('user/resetToken')
      store.dispatch('permission/generateRoutesCut', 0)
      router.push('/error')
      return
    }

    if (response.data.errCode !== 0 && response.data.errCode !== 100) {
      if (!noErrMsgPopup.includes(response.config.url)) {
        Message({
          message: response.data.errMsg,
          type: 'error',
          duration: 2 * 1000,
        })
      }

      if (!noIntercept.includes(response.config.url)) {
        return Promise.reject(response.data.errMsg)
      }
    }

    const res = response.data

    return res
  },
  error => {
    return againRequest(error, service)
    // if (error.response && (error.response.status === 502 || error.response.status === 503 || error.response.status === 500)) {
    //   store.dispatch('user/resetToken')
    //   router.replace('/error')
    // } else if (error.response && error.response.status === 504) {
    //   Message({
    //     message: '网络连接不稳定，请稍后重试',
    //     type: 'error',
    //     duration: 5 * 1000,
    //   })
    // } else if (error.message) {
    //   if (error.message.includes('timeout') || error.message.includes('Network Error')) {
    //     Message({
    //       message: '当前网络不稳定，请您稍后重试',
    //       type: 'error',
    //       duration: 5 * 1000,
    //     })
    //   } else {
    //     Message({
    //       message: error.message,
    //       type: 'error',
    //       duration: 5 * 1000,
    //     })
    //   }
    // }
    // return Promise.reject(error)
  }
)

export default service
